import clsx from 'clsx'
import React, {MouseEventHandler} from 'react'

import {Grid} from '../grid'
import {ChevronIcon} from '../icons'
import {Typographyv2 as Typography} from '../v2/typography'
import {classes} from './Tile.classes'

type Props = {
  onClick?: MouseEventHandler<HTMLDivElement>
  title: string
  subtitle?: string
  callToActionText?: string
  imgProps?: JSX.IntrinsicElements['img']
}

const Tile: React.FC<Props> = ({onClick, title, subtitle, callToActionText, imgProps}) => {
  return (
    <Grid className={classes.root} direction="column" justify="space-between" onClick={onClick} wrap="nowrap" container>
      <Grid direction="column" wrap="nowrap" container item>
        <Typography Component={Grid} thickness="medium" variant="body2" item>
          {title}
        </Typography>
        {subtitle && (
          <Typography Component={Grid} variant="caption1" item>
            {subtitle}
          </Typography>
        )}
      </Grid>
      {callToActionText && (
        <Grid alignItems="center" wrap="nowrap" container item>
          <Typography color="minor" Component={Grid} variant="caption1" item>
            {callToActionText}
          </Typography>
          <Grid className={classes.chevron} component={ChevronIcon} fontSize="small" item />
        </Grid>
      )}
      <Grid alt="" component="img" {...imgProps} className={clsx(classes.icon, imgProps?.className)} />
    </Grid>
  )
}

export default Tile
